export default __webpack_public_path__ + "static/media/kitchen3-afterH-1440w.69323ed0.webp";